import { instance } from "apis/interceptor";

type ResponseType<T> = {
  success: boolean;
  message?: string;
  statusCode?: number;
  data?: T;
};

export type TTabletAccount = {
  tabletAccountId: string;
  tabletAccountPassword: string;
}

//UPDATE: (new) 기기 로그인 계정 정보 조회
export const getWorkspacesTabletAccount = async (): Promise<ResponseType<TTabletAccount>> => {
  try {
    const res = await instance.get("/workspaces/tablet-account");
    return { success: true, data: res.data };
  } catch (error: any) {
    const status = error.response?.status;
    if (status === 403) {
        return { success: false, message: "권한이 없습니다." };
    } else return { success: false, message: "권한이 없습니다." };
  }
};

//UPDATE: (new) 기기 로그인 계정 정보 수정
export async function updateWorkspacesTabletAccount(tabletAccount: TTabletAccount): Promise<ResponseType<boolean>> {
  try {
      const res = await instance.patch(`/workspaces/tablet-account`, tabletAccount);
      return {success: res.data.result, message: ""};
    } catch (error: any) {
      const status = error.response?.status;
      if (status === 403) {
          return { success: false, statusCode: 403, message: "권한이 없습니다." };
      } else if (status === 409) {
        return { success: false, statusCode: 409, message: "이미 사용 중인 아이디입니다." };
      } else return { success: false, message: "기기 로그인 계정 정보 변경에 실패했습니다. 다시 시도해 주세요." };
    }
}